import React, { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton';
import LinesEllipsis from 'react-lines-ellipsis';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import Button from '@mui/material/Button';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { actionTypes, useStateValue } from "./../../store";
import { getProductStockAndPrice } from '../../networkCalls';
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage';

const MiniCartProductCell = ({ itemin, removeitem, itemno, minusQty, addQty }) => {

    const [productPrice, setProPrice] = useState(null);
    const [displayItemPrice, setDisplayItemPrice] = useState(null);

    const [availStock, setAvailStock] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [minQtyHold, setMinQtyHold] = useState(1);
    const [maxQtyHold, setMaxQtyHold] = useState(5);
    const [itemsubt, setitemsubt] = useState('');

    const [, dispatch] = useStateValue();

    const removeToCart = (value) => {
        removeitem(value);
    }
    const minQty = (value) => {
        minusQty(value);
    }
    const plusQty = (value) => {
        addQty(value);
    }
    const pullProductCellData = () => {
        var data = new FormData();
        data.append('whsId', itemin?.whsid);
        data.append('inventoryItemId', itemin?.inventoryItemId);
        data.append('id', itemin?.id);
        setLoading(true)
        getProductStockAndPrice(data).then((res) => {
            setLoading(false)
            switch (res.data.status) {
                case 1:
                    setProPrice(res.data?.itemPrice)
                    //setDisplayItemPrice(res.data?.displayItemPrice)
                    setDisplayItemPrice(parseFloat(res.data?.displayItemPrice).toFixed(2))
                    setAvailStock(res.data?.itemStock)
                    if (res.data?.itemStock < 5) {
                        setMaxQtyHold(res.data?.itemStock)
                    }
                    return true;
                case 0:
                    dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                    dispatch({ type: actionTypes.SET_MSGALERTDATA, value: data?.msz });
                    dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                    break;
                case 2:
                    dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
                    break;
                default:
                    return;
            }
        })
    }

    useEffect(() => {
        pullProductCellData();
    }, []);

    useEffect(() => {
        var myNumber = displayItemPrice;
        // console.log('hi', parseFloat(myNumber * itemin?.qty).toFixed(2))
        setitemsubt(parseFloat(myNumber * itemin?.qty).toFixed(2))
    }, [itemin?.qty, displayItemPrice]);



    return (
        <>
            <div className='p-3 bg-white'>
                {!isLoading ? <>
                    <div className='d-flex'>
                        <div className='border'><img src={itemin?.pimg} style={{ width: '70px' }} alt={itemin?.pname} /></div>
                        <div className='flex-grow-1 ms-2'>
                            <div className='d-flex'>
                                <div className='flex-grow-1'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            {itemin?.pname}
                                        </div>
                                        <div className='col-12 txtlgeay f12'>
                                            {itemin?.pcat}
                                        </div>
                                    </div>
                                </div>
                                <div className=''>
                                    <IconButton size="medium" onClick={() => { removeToCart(itemno) }} color="inherit" >
                                        <DeleteForeverOutlinedIcon color="error" />
                                    </IconButton>
                                </div>
                            </div>
                            <div className='row d-flex align-items-center'>
                                <div className='f14 col-6 col-md-4 pe-0'>
                                    {!isLoading ? <><CurrencyRupeeIcon className='f14' />{productPrice}</> : <></>}
                                </div>
                                <div className='d-flex align-items-center col-6 col-md-4'>
                                    {itemin?.qty <= minQtyHold ? <>
                                        <IconButton
                                            disabled
                                            size="medium" color="inherit" >
                                            <IndeterminateCheckBoxIcon color="bgdgray" />
                                        </IconButton>
                                    </> : <>
                                        <IconButton
                                            onClick={() => { minQty(itemin?.id) }} size="medium" color="inherit" >
                                            <IndeterminateCheckBoxIcon color="bgdgray" />
                                        </IconButton>
                                    </>}
                                    <div className='p-1 pe-2 ps-2 bgsgray'>
                                        {itemin?.qty}
                                    </div>
                                    {itemin?.qty >= maxQtyHold ? <>
                                        <IconButton
                                            disabled
                                            size="medium" color="inherit" >
                                            <AddBoxIcon color="bgdgray" />
                                        </IconButton>
                                    </> : <>
                                        <IconButton size="medium" onClick={() => { plusQty(itemin?.id) }} color="inherit" >
                                            <AddBoxIcon color="success" />
                                        </IconButton>
                                    </>}
                                </div>
                                <div className='text-start text-md-end col-12 col-md-4'>
                                    {!isLoading ? <>
                                        <div className='f16'>
                                            <CurrencyRupeeIcon className='f14' /> {itemsubt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br />
                                        </div>
                                    </> : <></>}
                                </div>
                            </div>
                        </div>
                    </div>
                </> : <LoadingCellFullPage />}

            </div>
        </>
    )
}

export default MiniCartProductCell